import { useEventListener } from '@nfinite/react-hubstairs/hooks'
import { Container, Position, ArrowIcon, Content, Button } from './styled'
import { useState } from 'react'
import ArrowTop from 'assets/svg/arrow_top_bar.svg?react'

const MIN_SCROLL_POSITION = 1000

function getScrollElement(element) {
  return !element ? window : element
}

function getScrollPosition(element) {
  return !element ? window.scrollY : element.scrollTop
}

export function GoToTop({ element, distanceFromBottom = -50 }) {
  const [visible, setVisible] = useState(false)

  function onScroll(e) {
    const scrollPosition = getScrollPosition(element)
    if (scrollPosition > MIN_SCROLL_POSITION) setVisible(true)
    else setVisible(false)
  }

  useEventListener('scroll', onScroll, getScrollElement(element))

  return (
    <Container>
      <Position visible={visible} distanceFromBottom={distanceFromBottom}>
        <Button onClick={() => getScrollElement(element).scrollTo({ top: 0, behavior: 'smooth' })}>
          <Content>
            <ArrowIcon component={ArrowTop} />
          </Content>
        </Button>
      </Position>
    </Container>
  )
}
